(() => {
  function normalize(text) {
    return text.replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function injectMobileProductWidthFix() {
    if (document.getElementById('sl-mobile-product-width-fix')) return;
    const style = document.createElement('style');
    style.id = 'sl-mobile-product-width-fix';
    style.textContent = `
      @media (max-width: 749px) {
        .sl-cro-trustbar,
        .sl-cro-trustbar *,
        .slx-announcement,
        .slx-announcement *,
        .slq-category-strip:empty,
        .slq-category-strip:has(.slideshow-controls),
        slideshow-controls,
        .slideshow-controls,
        .slider-counter,
        .slider-buttons,
        .slideshow-controls__counter,
        .slideshow-controls button[aria-label*='Slide'],
        .slideshow-controls button[aria-label*='slide'] {
          display: none !important;
          visibility: hidden !important;
          height: 0 !important;
          min-height: 0 !important;
          max-height: 0 !important;
          width: 0 !important;
          min-width: 0 !important;
          padding: 0 !important;
          margin: 0 !important;
          border: 0 !important;
          overflow: hidden !important;
          pointer-events: none !important;
        }

        .sl-mobile-sticky-atc,
        .sl-mobile-sticky-atc__title,
        .sl-mobile-sticky-atc__meta,
        .sl-mobile-sticky-atc__price,
        .sl-mobile-sticky-atc :not(button):not(.button):not([class*='btn']) {
          color: #121212 !important;
          opacity: 1 !important;
          text-shadow: none !important;
        }

        .sl-mobile-sticky-atc {
          background: #f4f4f4 !important;
          border: 1px solid rgba(18,18,18,.12) !important;
        }

        .sl-mobile-sticky-atc button,
        .sl-mobile-sticky-atc .button,
        .sl-mobile-sticky-atc [class*='btn'] {
          color: #0a0a0a !important;
          text-shadow: none !important;
        }

        .cart-page__summary,
        .cart-page__summary .cart__summary-container,
        .cart-page__summary .cart__summary-inner {
          color: #121212 !important;
        }

        .cart-page__summary .cart__summary-container,
        .cart-page__summary .cart__summary-inner {
          background: #f7f7f4 !important;
          border-color: rgba(18,18,18,.12) !important;
        }

        .cart-page__summary *,
        .cart-page__summary .cart__summary-item,
        .cart-page__summary .cart__total,
        .cart-page__summary .cart__total-label,
        .cart-page__summary .cart__total-value,
        .cart-page__summary .tax-note,
        .cart-page__summary .cart__tax-note,
        .cart-page__summary .disclosure-trigger,
        .cart-page__summary .disclosure-trigger__label,
        .cart-page__summary .sl-shipping-progress,
        .cart-page__summary .sl-shipping-progress * {
          color: #121212 !important;
          opacity: 1 !important;
          text-shadow: none !important;
        }

        .cart-page__summary .sl-shipping-progress,
        .sl-cart-trust {
          background: #f4f4f4 !important;
          border: 1px solid rgba(18,18,18,.12) !important;
          color: #121212 !important;
          opacity: 1 !important;
          text-shadow: none !important;
        }

        .sl-cart-trust * {
          color: #121212 !important;
          opacity: 1 !important;
          text-shadow: none !important;
        }

        .cart-page__summary .cart__checkout-button,
        .cart-page__summary .cart__checkout-button * {
          color: #fff !important;
        }

        .product-information__grid {
          display: flex !important;
          flex-direction: column !important;
          gap: 24px !important;
          width: min(100% - 24px, 560px) !important;
          max-width: 100% !important;
          margin-inline: auto !important;
        }

        .product-information__grid .product-information__media {
          order: 1 !important;
          display: block !important;
          width: 100% !important;
          min-width: 0 !important;
          max-width: 100% !important;
        }

        .product-information__grid .product-information__media > *,
        .product-information__grid .product-information__media media-gallery,
        .product-information__grid .product-information__media slideshow-component {
          width: 100% !important;
          max-width: 100% !important;
        }

        .product-information__grid .product-details {
          order: 2 !important;
          width: 100% !important;
          max-width: 100% !important;
          margin-inline: 0 !important;
          padding: 20px !important;
          box-sizing: border-box !important;
        }

        .product-details .group-block,
        .product-details .group-block-content,
        .product-details .text-block,
        .product-details .text-block h1 {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
        }

        .product-details .text-block h1,
        .product-details h1,
        .product-title,
        h1.product-title {
          font-size: clamp(1.85rem, 8.3vw, 2.35rem) !important;
          line-height: 1 !important;
          letter-spacing: -0.052em !important;
          overflow-wrap: normal !important;
          word-break: normal !important;
          hyphens: none !important;
        }

        .product-details .price,
        .product-details [class*='price'] {
          width: 100% !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function hideTopEllipsisBars() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('button, summary, [role="button"], div, span').forEach((node) => {
      const text = (node.textContent || '').trim();
      if (text !== '...' && text !== '…') return;
      const rect = node.getBoundingClientRect();
      if (rect.top < 120 || rect.top > 340) return;
      let target = node;
      for (let i = 0; i < 4 && target.parentElement; i += 1) {
        const parent = target.parentElement;
        const box = parent.getBoundingClientRect();
        if (box.width >= window.innerWidth * 0.75 && box.height >= 35 && box.top < 340) {
          target = parent;
        }
      }
      target.style.setProperty('display', 'none', 'important');
      target.style.setProperty('height', '0', 'important');
      target.style.setProperty('min-height', '0', 'important');
      target.style.setProperty('margin', '0', 'important');
      target.style.setProperty('padding', '0', 'important');
      target.style.setProperty('overflow', 'hidden', 'important');
      target.setAttribute('hidden', '');
    });
  }

  function fixLightSurfaceText() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.sl-mobile-sticky-atc, .sl-mobile-sticky-atc *').forEach((node) => {
      if (node.closest('button, .button, [class*="btn"]')) return;
      node.style.setProperty('color', '#121212', 'important');
      node.style.setProperty('opacity', '1', 'important');
      node.style.setProperty('text-shadow', 'none', 'important');
    });
    document.querySelectorAll('.sl-mobile-sticky-atc').forEach((node) => {
      node.style.setProperty('background', '#f4f4f4', 'important');
      node.style.setProperty('border-color', 'rgba(18,18,18,.12)', 'important');
    });
  }

  function fixCartTrustText() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.cart-page__summary, .cart-page__summary .cart__summary-container, .cart-page__summary .cart__summary-inner').forEach((box) => {
      box.style.setProperty('color', '#121212', 'important');
      box.querySelectorAll('*').forEach((child) => {
        if (child.closest('.cart__checkout-button')) return;
        child.style.setProperty('color', '#121212', 'important');
        child.style.setProperty('opacity', '1', 'important');
        child.style.setProperty('text-shadow', 'none', 'important');
      });
    });

    const matches = [...document.querySelectorAll('body *')].filter((node) => {
      const text = normalize(node.textContent || '');
      if (!text.includes('KOSTENLOSER VERSAND')) return false;
      if (!text.includes('RÜCKGABE') && !text.includes('RUECKGABE')) return false;
      return text.length < 180;
    });

    matches.forEach((node) => {
      const box = node.closest('.sl-cart-trust, [class*="trust"], [class*="shipping"], [class*="benefit"], [class*="promise"]') || node;
      box.classList.add('sl-cart-trust');
      box.style.setProperty('background', '#f4f4f4', 'important');
      box.style.setProperty('border', '1px solid rgba(18,18,18,.12)', 'important');
      box.style.setProperty('color', '#121212', 'important');
      box.style.setProperty('opacity', '1', 'important');
      box.querySelectorAll('*').forEach((child) => {
        child.style.setProperty('color', '#121212', 'important');
        child.style.setProperty('opacity', '1', 'important');
        child.style.setProperty('text-shadow', 'none', 'important');
      });
    });
  }

  function removeMobileEmptyBars() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.sl-cro-trustbar, .slx-announcement, slideshow-controls, .slideshow-controls, .slider-buttons, .slider-counter').forEach((node) => {
      node.setAttribute('hidden', '');
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('height', '0', 'important');
      node.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  function simplifyProductChips() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const replacements = new Map([
      ['AUF LAGER', 'BESTAND'],
      ['SICHERER CHECKOUT', 'CHECKOUT'],
      ['KLARE PRODUKTINFOS', 'INFOS'],
      ['KLARE PRODUKTINFO S', 'INFOS'],
      ['PASSENDES ZUBEHÖR', 'ZUBEHÖR'],
      ['PASSENDES ZUBEHOER', 'ZUBEHOER'],
    ]);

    document.querySelectorAll('.sl-product-promise strong').forEach((node) => {
      const key = normalize(node.textContent);
      if (replacements.has(key)) node.textContent = replacements.get(key);
    });
  }

  function simplifyProductAccordions() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.sl-product-info-box details').forEach((detail, index) => {
      if (index > 0) detail.removeAttribute('open');
    });
  }

  function run() {
    injectMobileProductWidthFix();
    removeMobileEmptyBars();
    hideTopEllipsisBars();
    fixLightSurfaceText();
    fixCartTrustText();
    simplifyProductChips();
    simplifyProductAccordions();
    [300, 900, 1600, 2600].forEach((delay) => {
      window.setTimeout(removeMobileEmptyBars, delay);
      window.setTimeout(hideTopEllipsisBars, delay);
      window.setTimeout(fixLightSurfaceText, delay);
      window.setTimeout(fixCartTrustText, delay);
    });
    window.setTimeout(simplifyProductChips, 500);
    window.setTimeout(simplifyProductChips, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
